import { Smile } from "lucide-react";

export function PatientOdontogramaTab({ patientId: _patientId }: { patientId: string }) {
  return (
    <div className="space-y-4">
      <div>
        <h3 className="text-sm font-semibold text-zinc-900">Odontograma</h3>
        <p className="mt-1 text-xs text-zinc-500">
          Mapa visual dos dentes do paciente — estado, procedimentos, anotações por face.
        </p>
      </div>

      <div className="rounded-xl border border-dashed border-zinc-200 bg-zinc-50/50 p-8 text-center">
        <Smile className="mx-auto h-10 w-10 text-zinc-300" />
        <p className="mt-3 text-sm font-medium text-zinc-700">Odontograma — em desenvolvimento</p>
        <p className="mt-1 text-xs text-zinc-500">
          Em breve: SVG interativo da arcada completa, marcação por face, cores por estado
          (tratado, a tratar, extraído, ausente) e histórico de alterações.
        </p>
      </div>
    </div>
  );
}
